import { doGet } from 'utils/api';
import { RELEASES } from 'utils/environment';

const LOAD_BANNER_FEED_SUCCESS = 'LOAD_BANNER_FEED_SUCCESS';
const LOAD_BANNER_FEED_FAIL = 'LOAD_BANNER_FEED_FAIL';

const initialState = {
  banner: [],
  displayBanner: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_BANNER_FEED_SUCCESS:
      return {
        ...state,
        banner: action.banner,
        displayBanner: true,
      };
    case LOAD_BANNER_FEED_FAIL:
      return {
        ...state,
        banner: [],
        displayBanner: false,
      };
    default:
      return state;
  }
}

export function loadBannerFeed() {
  return dispatch => {
    return doGet('banners.json')
      .then(response => {
        response
          .json()
          .then(json => {
            if (json[RELEASES[0]]) {
              return dispatch({
                type: LOAD_BANNER_FEED_SUCCESS,
                banner: [json[RELEASES[0]]],
              });
            }
            return false;
          })
          .catch(() => {
            console.error('Banner JSON not formatted correctly');
            return dispatch({
              type: LOAD_BANNER_FEED_FAIL,
            });
          });
        return true;
      })
      .catch(function(error) {
        console.log(error);
        return dispatch({
          type: LOAD_BANNER_FEED_FAIL,
        });
      });
  };
}
